import React from 'react';
import classnames from 'classnames';
import styles from '../cms.module.scss';

export const Title = ({ value: { level, text }, headingLevel = 0 }) => {
  const absoluteLevel = Math.min(headingLevel + (Number(level) || 1), 6);
  const Heading = `h${absoluteLevel}`;

  return (
    <Heading
      className={classnames(
        styles.cms__title,
        styles[`cms__title--${Heading}`],
      )}
    >
      {text}
    </Heading>
  );
};

export default Title;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/Title/index.js